import type {
	ShopDto,
	UpdateOneOneStockIntegrationDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateOneStockIntegration(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/integrations/onestock",
		{
			invalidate: invalidateShop,
			mapVariables: (requestBody: UpdateOneOneStockIntegrationDto) => ({
				params: { path: { shopId: shop.id } },
				body: requestBody,
			}),
		},
	);
}
